import { Stack, Typography } from '@mui/material';
import RadioButtonCheckedOutlined from '@mui/icons-material/RadioButtonCheckedOutlined';
import RadioButtonUncheckedOutlined from '@mui/icons-material/RadioButtonUncheckedOutlined';
import { KeyValueList, type KeyValue } from '../../../components/KeyValueList';
import { LinksPanel } from '../../../components/LinksPanel';
import { Panel } from '../../../components/Panel';
import { NEXT_STEPS, type ShipmentForm } from './shipmentForm';

const dash = (v: string, suffix = '') => (v ? v + suffix : '—');
/** 2026-10-18 → 18/10/2026 */
const date = (iso: string) => (iso ? iso.split('-').reverse().join('/') : '—');

/** The shipment as typed so far, in one small table */
export function SummaryPanel({ form }: { form: ShipmentForm }) {
  const rows: KeyValue[] = [
    { label: 'SRB Code', value: dash(form.srb) },
    { label: 'Customer', value: dash(form.customer) },
    {
      label: 'Route',
      value: form.origin || form.destination ? `${dash(form.origin)} → ${dash(form.destination)}` : '—',
    },
    { label: 'Mode / Type', value: form.mode || form.shipmentType ? `${form.mode} / ${form.shipmentType}` : '—' },
    { label: 'Incoterm', value: dash(form.incoterm) },
    { label: 'Commodity', value: dash(form.commodity) },
    { label: 'Packages', value: form.packages ? `${form.packages} ${form.packageUnit}` : '—' },
    { label: 'Gross Weight', value: form.grossWeight ? `${Number(form.grossWeight).toLocaleString('en-US')} kg` : '—' },
    { label: 'Volume', value: dash(form.volume, ' CBM') },
    { label: 'Stackability', value: form.stackable },
    { label: 'Dangerous Goods', value: form.dangerous },
    { label: 'Cargo Ready Date', value: date(form.readyDate) },
    { label: 'Status', value: 'RFQ' },
    { label: 'Created By', value: dash(form.operator) },
    { label: 'Created Date', value: date(form.created) },
  ];
  return (
    <Panel title="Shipment Summary">
      <KeyValueList rows={rows} />
    </Panel>
  );
}

export function NextStepsPanel() {
  return (
    <Panel title="Next Steps">
      <Stack spacing={0.5}>
        {NEXT_STEPS.map((step, i) => (
          <Stack
            key={step}
            direction="row"
            spacing={1}
            sx={{ alignItems: 'center', p: 0.75, borderRadius: 1.5, bgcolor: i === 0 ? 'action.hover' : undefined }}
          >
            {i === 0 ? (
              <RadioButtonCheckedOutlined color="primary" fontSize="small" />
            ) : (
              <RadioButtonUncheckedOutlined color="disabled" fontSize="small" />
            )}
            <Typography variant="body2" sx={{ fontWeight: i === 0 ? 650 : 400 }}>
              {step}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Panel>
  );
}

const RELATED = [
  { label: 'Quotations', to: '/quotations', count: 0 },
  { label: 'Documents', to: '/documents', count: 0 },
  { label: 'Communications', to: '/communications', count: 0 },
  { label: 'Activity History', to: '/history' },
];

/** Where this shipment's other things will be, once it exists */
export const RelatedPanel = () => <LinksPanel title="Related" items={RELATED} />;
